export function get(data, filters)
{
	filters = filters || {};

    return axios.post(
    	route('api.manage.companies.bulk'),
    	data,
    	{ params: { ...filters } }
    )
    	.then(response => response.data);
}
